import type {
  CreateSafetyLogFormValues,
  CreateSafetyLogRequestDto,
  SafetyLog,
  SafetyLogItem,
  SafetyLogItemDto,
  SafetyLogResponseDto,
  UpdateSafetyLogFormValues,
  UpdateSafetyLogRequestDto,
} from './safety-log.dto';

export const mapSafetyLogItem = ({
  remarks_compliance,
  date,
  expiration,
  ...rest
}: SafetyLogItemDto): SafetyLogItem => ({
  ...rest,
  remarksCompliance: remarks_compliance,
  date: date ?? '',
  expiration: expiration ?? '',
});

export const mapSafetyLogItemDto = ({
  remarksCompliance,
  date,
  expiration,
  ...rest
}: SafetyLogItem): SafetyLogItemDto => ({
  ...rest,
  remarks_compliance: remarksCompliance,
  // Only send a timestamp when one was actually set — the backend rejects invalid/empty dates.
  ...(date ? { date } : {}),
  ...(expiration ? { expiration } : {}),
});

export const mapSafetyLog = ({
  vessel_id,
  vessel_name,
  responsible_id,
  responsible_name,
  responsible_signed_at,
  created_at,
  updated_at,
  items,
  ...rest
}: SafetyLogResponseDto): SafetyLog => ({
  ...rest,
  vesselId: vessel_id,
  vesselName: vessel_name,
  responsibleId: responsible_id,
  responsibleName: responsible_name,
  responsibleSignedAt: responsible_signed_at,
  createdAt: created_at,
  updatedAt: updated_at,
  items: (items ?? []).map(mapSafetyLogItem),
});

const toRfc3339 = (date: string): string => {
  const d = new Date(date.length === 10 ? `${date}T00:00:00.000Z` : date);
  return Number.isNaN(d.getTime()) ? date : d.toISOString();
};

export const mapCreateSafetyLogDto = ({
  date,
  items,
}: CreateSafetyLogFormValues): CreateSafetyLogRequestDto => ({
  date: toRfc3339(date),
  items: items?.map(mapSafetyLogItemDto),
});

export const mapUpdateSafetyLogDto = ({
  id,
  items,
}: UpdateSafetyLogFormValues): UpdateSafetyLogRequestDto => ({
  id,
  items: items?.map(mapSafetyLogItemDto),
});
